import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadInstitutionFinanceByInstitutionId: IInstitutionFinanceLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_LOAD_BY_INSTITUTION_ID,
            institutionId
        }
    },
    LoadInstitutionFinanceById: IInstitutionFinanceLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IInstitutionFinanceLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionFinanceLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveInstitutionFinance: IInstitutionFinanceSaveActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_SAVE,
            formData
        }
    },
    SaveSuccess: IInstitutionFinanceSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IInstitutionFinanceSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateInstitutionFinance: IInstitutionFinanceValidateActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IInstitutionFinanceValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IInstitutionFinanceValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateInstitutionFinance: IInstitutionFinanceCreateActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONFINANCE_CREATE,
            institutionId
        }
    },
    CreateSuccess: IInstitutionFinanceCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IInstitutionFinanceCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncInstitutionFinance: IInstitutionFinanceSyncActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONFINANCE_SYNC,
            institutionId
        }
    },
    SyncSuccess: IInstitutionFinanceSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: IInstitutionFinanceSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: IInstitutionFinanceClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_CLEAR,
            propertiesToClear
        }
    },

    Filter: IInstitutionFinanceFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTIONFINANCE_FILTER,
            formFilter
        }
    };



export const
    ACTION_INSTITUTIONFINANCE_LOAD_BY_INSTITUTION_ID = "ACTION_INSTITUTIONFINANCE_LOAD_BY_INSTITUTION_ID",
    ACTION_INSTITUTIONFINANCE_LOAD_BY_ID = "ACTION_INSTITUTIONFINANCE_LOAD_BY_ID",
    ACTION_INSTITUTIONFINANCE_LOAD_SUCCESS = "ACTION_INSTITUTIONFINANCE_LOAD_SUCCESS",
    ACTION_INSTITUTIONFINANCE_LOAD_FAILURE = "ACTION_INSTITUTIONFINANCE_LOAD_FAILURE",

    ACTION_INSTITUTIONFINANCE_SAVE = "ACTION_INSTITUTIONFINANCE_SAVE",
    ACTION_INSTITUTIONFINANCE_SAVE_SUCCESS = "ACTION_INSTITUTIONFINANCE_SAVE_SUCCESS",
    ACTION_INSTITUTIONFINANCE_SAVE_FAILURE = "ACTION_INSTITUTIONFINANCE_SAVE_FAILURE",

    ACTION_INSTITUTIONFINANCE_VALIDATE = "ACTION_INSTITUTIONFINANCE_VALIDATE",
    ACTION_INSTITUTIONFINANCE_VALIDATE_SUCCESS = "ACTION_INSTITUTIONFINANCE_VALIDATE_SUCCESS",
    ACTION_INSTITUTIONFINANCE_VALIDATE_FAILURE = "ACTION_INSTITUTIONFINANCE_VALIDATE_FAILURE",

    ACTION_INSTITUTIONFINANCE_CREATE = "ACTION_INSTITUTIONFINANCE_CREATE",
    ACTION_INSTITUTIONFINANCE_CREATE_SUCCESS = "ACTION_INSTITUTIONFINANCE_CREATE_SUCCESS",
    ACTION_INSTITUTIONFINANCE_CREATE_FAILURE = "ACTION_INSTITUTIONFINANCE_CREATE_FAILURE",

    ACTION_INSTITUTIONFINANCE_SYNC = "ACTION_INSTITUTIONFINANCE_SYNC",
    ACTION_INSTITUTIONFINANCE_SYNC_SUCCESS = "ACTION_INSTITUTIONFINANCE_SYNC_SUCCESS",
    ACTION_INSTITUTIONFINANCE_SYNC_FAILURE = "ACTION_INSTITUTIONFINANCE_SYNC_FAILURE",

    ACTION_INSTITUTIONFINANCE_CLEAR = "ACTION_INSTITUTIONFINANCE_CLEAR",

    ACTION_INSTITUTIONFINANCE_FILTER = "ACTION_INSTITUTIONFINANCE_FILTER";

export interface IInstitutionFinanceLoadByInstitutionIdAction {
    type: "ACTION_INSTITUTIONFINANCE_LOAD_BY_INSTITUTION_ID";
    institutionId: number;
}

export interface IInstitutionFinanceLoadByInstitutionIdActionCreator {
    (institutionId: number): IInstitutionFinanceLoadByInstitutionIdAction;
}

export interface IInstitutionFinanceLoadSuccessAction {
    type: "ACTION_INSTITUTIONFINANCE_LOAD_SUCCESS";
    formData: Dtos.InstitutionFinance | Dtos.InstitutionFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionFinanceLoadSuccessActionCreator {
    (
        formData: Dtos.InstitutionFinance | Dtos.InstitutionFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionFinanceLoadSuccessAction;
}

export interface IInstitutionFinanceLoadFailureAction {
    type: "ACTION_INSTITUTIONFINANCE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionFinanceLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionFinanceLoadFailureAction;
}

export interface IInstitutionFinanceLoadByIdAction {
    type: "ACTION_INSTITUTIONFINANCE_LOAD_BY_ID";
    id: number;
}

export interface IInstitutionFinanceLoadByIdActionCreator {
    (id: number): IInstitutionFinanceLoadByIdAction;
}

export interface IInstitutionFinanceSaveAction {
    type: "ACTION_INSTITUTIONFINANCE_SAVE";
    formData: Dtos.InstitutionFinance;

}

export interface IInstitutionFinanceSaveActionCreator {
    (
        formData: Dtos.InstitutionFinance
    ): IInstitutionFinanceSaveAction;
}

export interface IInstitutionFinanceSaveSuccessAction {
    type: "ACTION_INSTITUTIONFINANCE_SAVE_SUCCESS";
    formData: Dtos.InstitutionFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionFinanceSaveSuccessActionCreator {
    (
        formData: Dtos.InstitutionFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionFinanceSaveSuccessAction;
}

export interface IInstitutionFinanceSaveFailureAction {
    type: "ACTION_INSTITUTIONFINANCE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionFinanceSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionFinanceSaveFailureAction;
}

export interface IInstitutionFinanceValidateAction {
    type: "ACTION_INSTITUTIONFINANCE_VALIDATE";
    formData: Dtos.InstitutionFinance;

}

export interface IInstitutionFinanceValidateActionCreator {
    (
        formData: Dtos.InstitutionFinance
    ): IInstitutionFinanceValidateAction;
}

export interface IInstitutionFinanceValidateSuccessAction {
    type: "ACTION_INSTITUTIONFINANCE_VALIDATE_SUCCESS";
    formData: Dtos.InstitutionFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionFinanceValidateSuccessActionCreator {
    (
        formData: Dtos.InstitutionFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionFinanceValidateSuccessAction;
}

export interface IInstitutionFinanceValidateFailureAction {
    type: "ACTION_INSTITUTIONFINANCE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionFinanceValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionFinanceValidateFailureAction;
}

export interface IInstitutionFinanceCreateAction {
    type: "ACTION_INSTITUTIONFINANCE_CREATE",
    institutionId: number
}

export interface IInstitutionFinanceCreateActionCreator {
    (institutionId: number): IInstitutionFinanceCreateAction
}

export interface IInstitutionFinanceCreateSuccessAction {
    type: "ACTION_INSTITUTIONFINANCE_CREATE_SUCCESS";
    formData: Dtos.InstitutionFinance;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IInstitutionFinanceCreateSuccessActionCreator {
    (
        formData: Dtos.InstitutionFinance,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IInstitutionFinanceCreateSuccessAction;
}

export interface IInstitutionFinanceCreateFailureAction {
    type: "ACTION_INSTITUTIONFINANCE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionFinanceCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionFinanceCreateFailureAction;
}

export interface IInstitutionFinanceClearAction {
    type: "ACTION_INSTITUTIONFINANCE_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionFinanceClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionFinanceClearAction;
}

export interface IInstitutionFinanceFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionFinanceFilterAction;
}

export interface IInstitutionFinanceFilterAction {
    type: "ACTION_INSTITUTIONFINANCE_FILTER";
    formFilter: IFormFilter;
}

export interface IInstitutionFinanceSyncAction {
    type: "ACTION_INSTITUTIONFINANCE_SYNC",
    institutionId: number
}

export interface IInstitutionFinanceSyncActionCreator {
    (institutionId: number): IInstitutionFinanceSyncAction
}

export interface IInstitutionFinanceSyncSuccessAction {
    type: "ACTION_INSTITUTIONFINANCE_SYNC_SUCCESS";
    formData: Dtos.InstitutionFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionFinanceSyncSuccessActionCreator {
    (
        formData: Dtos.InstitutionFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionFinanceSyncSuccessAction;
}

export interface IInstitutionFinanceSyncFailureAction {
    type: "ACTION_INSTITUTIONFINANCE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionFinanceSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionFinanceSyncFailureAction;
}

export type InstitutionFinanceAction =
    IInstitutionFinanceLoadByInstitutionIdAction |
    IInstitutionFinanceLoadByIdAction |
    IInstitutionFinanceLoadFailureAction |
    IInstitutionFinanceLoadSuccessAction |
    IInstitutionFinanceSaveAction |
    IInstitutionFinanceSaveSuccessAction |
    IInstitutionFinanceSaveFailureAction |
    IInstitutionFinanceValidateAction |
    IInstitutionFinanceValidateSuccessAction |
    IInstitutionFinanceValidateFailureAction |
    IInstitutionFinanceCreateAction |
    IInstitutionFinanceCreateSuccessAction |
    IInstitutionFinanceCreateFailureAction |
    IInstitutionFinanceSyncAction |
    IInstitutionFinanceSyncSuccessAction |
    IInstitutionFinanceSyncFailureAction |
    IInstitutionFinanceClearAction | 
    IInstitutionFinanceFilterAction;
